// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import Cart from "../containers/Cart";
import { useTranslation } from 'react-i18next';

export default function CartView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Cart")} showShopToolbar={false}>
      <Cart />
    </PageContainer>
  );
}
